<!--  -->
<template>
  <div class="add_box">
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-input
            v-model.trim="query.name"
            placeholder="请输入名称"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="menuList"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="resetTencentAdqAdverList"
        >重置</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >

      <el-table-column
        align="center"
        prop="id"
        label="管理员id"
        width="200"
      />
      <el-table-column
        align="center"
        prop="name"
        label="管理员账号"
      />
      <el-table-column
        align="center"
        prop="nickname"
        label="管理员昵称"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'

import { wechat_auth_accountAdmin } from '@/api/customer.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        page: 1,
        page_size: 10,
        name: null
      },
      tableData: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      const data = await wechat_auth_accountAdmin(this.query)
      console.log('data', data)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    resetTencentAdqAdverList() {
      this.query = {
        page: 1,
        page_size: 10,
        name: null
      }
      this.menuList()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    sendr() {
      console.log(444)
      this.menuList()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keyword = null
      this.objr.status = null
      this.menuList()
    },
    chooser(item) {
      console.log(item)
      this.$emit('bandarr', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
